module.exports = __webpack_public_path__ + "static/media/diplom1.b5157422.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/store/designer/diplom1.jpg
// module id = 205
// module chunks = 0